import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
// url 공통화

createApp(App).use(router).mount("#app");
